export const formatDate = (date) => {

	// Changes date string from zulu time to readable, sortable yyyy-mm-dd

	return date.split("T")[0]

}
